export default __webpack_public_path__ + "fe374e2a81c802730323ebd5f233048f.png";